import { render } from "./HeroBackgroundHeat.vue?vue&type=template&id=01206ca0&ts=true"
import script from "./HeroBackgroundHeat.vue?vue&type=script&lang=ts"
export * from "./HeroBackgroundHeat.vue?vue&type=script&lang=ts"

import "./HeroBackgroundHeat.vue?vue&type=style&index=0&id=01206ca0&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__